import { __assign, __rest } from "tslib";
import React from 'react';
import VeltMediaSourceSettingsOptionsItemLabelWireframe from './VeltMediaSourceSettingsOptionsItemLabelWireframe/VeltMediaSourceSettingsOptionsItemLabelWireframe';
import VeltMediaSourceSettingsOptionsItemIconWireframe from './VeltMediaSourceSettingsOptionsItemIconWireframe/VeltMediaSourceSettingsOptionsItemIconWireframe';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltMediaSourceSettingsOptionsItemWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-media-source-settings-options-item-wireframe", __assign({}, transformedProps), children));
};
VeltMediaSourceSettingsOptionsItemWireframe.Icon = VeltMediaSourceSettingsOptionsItemIconWireframe;
VeltMediaSourceSettingsOptionsItemWireframe.Label = VeltMediaSourceSettingsOptionsItemLabelWireframe;
export default VeltMediaSourceSettingsOptionsItemWireframe;
